import React from "react";
import ActionCard from "../components/ActionCard";

export default function ActionPg(props) {
    const {buttonAction} = (props.match.params)  
    return(
        <div className ="actionPg">
            <ActionCard {...props} title = {buttonAction} />
        </div>
    )
}